var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileDarkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 24,
    viewBox: "0 0 96 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5567 16.5634L18.405 0H25.1134L15.9969 23.662H9.11649L0 0H6.70836L12.5567 16.5634Z",
    fill: "#091C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.08 0H30.6163L36.2926 11.493L41.9689 0H48.5053L39.3888 17.4085V23.662H33.1964V17.4085L24.08 0Z",
    fill: "#091C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8479 23.1549C64.4812 23.7183 59.5502 24 55.0551 24C52.8075 24 51.1562 23.4817 50.1012 22.4451C49.0462 21.4085 48.5187 19.7859 48.5187 17.5775V6.76056C48.5187 4.39437 49.0577 2.68169 50.1356 1.62254C51.2365 0.540846 52.991 0 55.3991 0H67.7838V4.7324H56.7752C55.3991 4.7324 54.7111 5.40845 54.7111 6.76056V17.5775C54.7111 18.0958 54.8601 18.5127 55.1583 18.8282C55.4794 19.1211 55.9036 19.2676 56.4311 19.2676C59.0686 19.2676 61.4767 19.2113 63.6555 19.0986V14.1972H59.1833V10.1408H69.8479V23.1549Z",
    fill: "#091C00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.595 23.662H70.8866L80.0031 0H86.8835L96 23.662H89.2916L87.7436 19.4366H79.1431L77.595 23.662ZM80.6912 15.0423H86.1955L83.4433 7.09859L80.6912 15.0423Z",
    fill: "#091C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDarkLogo);
export default __webpack_public_path__ + "static/media/MobileDarkLogo.7e751513b72731b60721f7e5b747871f.svg";
export { ForwardRef as ReactComponent };